import $ from 'jquery';
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const staff = () => {
    const swiperContainer = document.querySelector('.js-staff-swiper');
    if (!swiperContainer) return;

    const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
    const isSp = window.matchMedia('(max-width: 768px)').matches;
    const threshold = isSp ? 3 : 6;

    // スライド数が閾値以下の場合はSwiperクラスを削除してグリッド表示
    if (slideCount <= threshold) {
        swiperContainer.classList.remove('swiper');
        const wrapper = swiperContainer.querySelector('.swiper-wrapper');
        if (wrapper) {
            wrapper.classList.remove('swiper-wrapper');
        }
        swiperContainer.querySelectorAll('.swiper-slide').forEach(slide => {
            slide.classList.remove('swiper-slide');
        });
        return;
    }

    // Swiper初期化
    const swiper = new Swiper(swiperContainer, {
        modules: [Autoplay],
        loop: true,
        //slidesPerView: isSp ? 3 : 6,
        spaceBetween: 20,
        slidesPerView: 'auto',
        speed: 10000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        freeMode: true,
        freeModeMomentum: false,
        allowTouchMove: true,
    });

    // CSSトランジションを滑らかに
    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (wrapper) {
        wrapper.style.transitionTimingFunction = 'linear';
    }
};

const faq = () => {
  $('.js-accordion').on('click', function(){
    const $this = $(this);
    const $content = $this.next();

    $content.slideToggle();

    // data-open属性の付与・削除
    if ($this.attr('data-open') !== undefined) {
      $this.removeAttr('data-open');
      $content.removeAttr('data-open');
    } else {
      $this.attr('data-open', '');
      $content.attr('data-open', '');
    }
  });
}

const voice = () => {
    const swiperContainer = document.querySelector('.js-voice-swiper');
    if (!swiperContainer) return;

    const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
    const isSp = window.matchMedia('(max-width: 768px)').matches;
    const threshold = isSp ? 1 : 3;

    // スライド数が閾値以下の場合はSwiperクラスを削除してグリッド表示
    if (slideCount <= threshold) {
        swiperContainer.classList.remove('swiper');
        const wrapper = swiperContainer.querySelector('.swiper-wrapper');
        if (wrapper) {
            wrapper.classList.remove('swiper-wrapper');
        }
        swiperContainer.querySelectorAll('.swiper-slide').forEach(slide => {
            slide.classList.remove('swiper-slide');
        });
        return;
    }

    // Swiper初期化
    const swiper = new Swiper(swiperContainer, {
        modules: [Autoplay],
        loop: true,
        slidesPerView: isSp ? 1 : 3,
        spaceBetween: 20,
        speed: 10000,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        freeMode: true,
        freeModeMomentum: false,
        allowTouchMove: true,
    });

    // CSSトランジションを滑らかに
    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (wrapper) {
        wrapper.style.transitionTimingFunction = 'linear';
    }
};


const main = () => {
    if (document.querySelector('#page-sell') === null) return;
    staff();
    faq();
    voice();
};


export default main;
